"use strict";

class Helpers {
    constructor(initALL = true, img) {
        console.log('Init Helpers module');
        if (initALL) this.initInfoLinks().initNumberInputs();
        this.img = img;
    }

    initInfoLinks() {
        $('.convectors-menu a[data-toggle="pill"], .reserves-menu a[data-toggle="pill"]').on('shown.bs.tab', event => {
            console.log("+++++++++++initInfoLinks", event.target.href);
            let infoLink = "#";
            let tmpArray = event.target.href.split('#');
            let selectedTabName = tmpArray[tmpArray.length - 1];
            switch (selectedTabName) {
                case "ITT":
                    infoLink = "#";
                    break;
                case "ITTB":
                    infoLink = "#";
                    break;
                case "ITTL":
                    infoLink = "#";
                    break;
                case "ITTBL":
                    infoLink = "#";
                    break;
                case "ITTZ":
                    infoLink = "https://itermic.kz/catalog/vstraivaemye-konvektory/s-estestvennoy-konvektsiey/konvektor-serii-ittz-standartnaya-seriya";
                    break;
                case "ITTBZ":
                    infoLink = "https://itermic.kz/catalog/vstraivaemye-konvektory/s-prinuditelnoy-konvektsiey/konvektor-serii-ittbz-standartnaya-seriya";
                    break;
                case "ITF":
                    infoLink = "https://itermic.kz/catalog/napolnye-i-nastennye/napolnye-konvektory/napolnye-konvektory-serii-itf";
                    break;
                case "automation":
                    infoLink = "https://itermic.ru/catalog/automation/";
                    break;
            }
            $("#infoLink").prop("href", infoLink).find(".label").text("О серии " + selectedTabName);
        }).filter("[href='#ITTZ']").tab('show');

        return this;
    }

    initNumberInputs() {
        $("body").on("change", "input[type=number]", (event) => {
            event.currentTarget.value = parseInt(event.currentTarget.value);
        });

        return this;
    }

    static hash(source) {
        /* Simple hash function. */
        var a = 1, c = 0, h, o;
        if (source) {
            a = 0;
            /*jshint plusplus:false bitwise:false*/
            for (h = source.length - 1; h >= 0; h--) {
                o = source.charCodeAt(h);
                a = (a << 6 & 268435455) + o + (o << 14);
                c = a & 266338304;
                a = c !== 0 ? a ^ c >> 21 : a;
            }
        }
        return String(a);
    }

    static numberWithCommas(x) {
        return x.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    static pad(number, paddingSize) {
        let s = String(number);
        while (s.length < (paddingSize || 2)) {
            s = "0" + s;
        }
        return s;
    }

    static cleanSpaces(aString) {
        return ((aString.replace) ? aString.replace(/[ \u00A0\u2007\u202F\u2060]/g, "") : "");
    }

    toString() {
        return JSON.stringify({
            img: this.img
        })
    }
}

export default Helpers;